import { Controller } from 'stimulus';
import Swiper, { Navigation } from 'swiper';
Swiper.use([Navigation]);

export default class extends Controller {
  static targets = ['prev', 'next', 'slider'];

  get numberOfSlides() {
    return this.element.querySelectorAll('.js-eatDrinkSlider .swiper-slide').length;
  }

  connect() {
    this.initSlider();
  }

  disconnect() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
    }
  }

  initSlider() {
    if (this.swiper) {
      this.swiper.update();
    } else {
      this.swiper = new Swiper(this.sliderTarget, {
        slidesPerView: 1.1,
        loop: false,
        speed: 400,
        autoHeight: true,
        observeParents: true,
        observer: true,
        spaceBetween: 25,
        slidesOffsetAfter: 25,
        navigation: {
          prevEl: this.prevTarget,
          nextEl: this.nextTarget,
        },
        breakpoints: {
          700: {
            spaceBetween: 35,
            slidesOffsetAfter: 35,
            slidesPerView: this.numberOfSlides > 2 ? 2.25 : 2,
          },
          1024: {
            slidesPerView: this.numberOfSlides > 3 ? 3.25 : 3,
          },
          1280: {
            spaceBetween: 50,
            slidesOffsetAfter: 50,
            slidesPerView: this.numberOfSlides > 3 ? 3.5 : 3,
          },
        },
      });
    }
  }
}
